import { GuardResult, MaybeAsync, Router } from '@angular/router';
import { Injectable } from '@angular/core';

type IEmployeeVandenBorreOrderRedirectState = {
  orderId: string;
  isVandenBorreOrderRedirect: true;
};

export function isVandenBorreOrderRedirectState(
  value: any
): value is IEmployeeVandenBorreOrderRedirectState {
  if (!value || typeof value !== 'object') {
    return false;
  }
  return (
    'isVandenBorreOrderRedirect' in value &&
    'orderId' in value &&
    value.isVandenBorreOrderRedirect &&
    !!value.orderId
  );
}

@Injectable()
export class EmployeeVandenBorreOrderGuardService {
  constructor(protected readonly router: Router) {}

  canActivate(): MaybeAsync<GuardResult> {
    const orderId = this.router.currentNavigation()?.extractedUrl?.queryParams?.OrderId;

    if (!orderId) {
      return this.router.navigate(['/employee'], { replaceUrl: true });
    }

    const state: IEmployeeVandenBorreOrderRedirectState = {
      orderId,
      isVandenBorreOrderRedirect: true,
    };

    return this.router.navigate(['/employee'], {
      replaceUrl: true,
      state,
    });
  }
}
